import '@/assets/styles/main.css'

import { createApp } from 'vue'
import App from '@/app/App.vue'
import { registerProviders } from '@/app/providers'
import { useTenantStore } from '@/stores/tenant'
import { applyBranding } from '@/themes/applyBranding'
import { loadLocaleMessages } from '@/i18n'
import { appConfig } from '@/app/config'

const app = createApp(App)
registerProviders(app)

const tenantStore = useTenantStore()

applyBranding(tenantStore.branding)

await loadLocaleMessages(appConfig.defaultLocale)

app.mount('#app')
